// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5128) return "static/chunks/5128-d82625aa5e092efd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3154":"4fe5746c0cefa06f","7268":"e5f22ad489cef096","7561":"33a584397be8f8a7","9942":"e619b28dd44ea4e2"}[chunkId] + ".js";
};